import React, { useState, useEffect } from 'react';
import { Button, Dialog, Box, makeStyles, DialogTitle, DialogContent, TextField, Slide  } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { CORP_BLUE } from '../../../config/config';
import { ErrorMessage } from "@hookform/error-message";
import { useForm } from "react-hook-form";
import { Select, InputLabel, MenuItem, FormControlLabel, Checkbox,  RadioGroup, Radio } from '@material-ui/core';
import { useTheme } from '@mui/material/styles';
import { cleanRut, singleInputValidator, validate } from '../../commons/utils';
import { validateRut } from '@fdograph/rut-utilities';
import { getDatosCiudadanoPorRut, ginterna } from '../../../service/service.supersalud';
import Divider from '@material-ui/core/Divider';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

const addStyle = makeStyles(theme => ({
    dialogRoot: {
        position: 'relative',
    },
    dialogTitleRoot: {
        backgroundColor: CORP_BLUE,
        '& .MuiTypography-h6': {
            fontSize: 16,
            color: 'white',
            fontWeight: 'bold'
        },

    },
}));


const GestionesInternasModal = (props) => {

    
    const { user, userLogOut, userLoggedIn, closeModal, folioInterno, submitModal, openDialog  } = props;
    
    const [folio, setFolio] = useState("");
    const [loading, setLoading] = useState(false);
    const { errors, setError } = useForm();
    /* variables formulario  */
    const [nombre, setNombre] = useState("");
    const [rut, setRut] = useState("");
    const [apellidoP, setApellidoP] = useState("");
    const [apellidoM, setApellidoM] = useState("");
    const [telefono, setTelefono] = useState();
    const [correo, setCorreo] = useState("");
    const [antecedentesgenerales, setAntecedentesgenerales] = useState("");
    const [solicitudConcreta, setSolicitudConcreta] = useState("");
    const [spinner, setSpinner]=useState(false)
    const [fullWidth, setFullWidth] = React.useState(true);
    const [maxWidth, setMaxWidth] = React.useState('lg');
    const theme = useTheme();
    const classes = addStyle();
    const [validateForm, setValidateForm] = useState(true)

    const [show, setShow] = useState(false);
    const [showComprobante, setShowComprobante] = useState(true);
    const [values, setValues] = useState({rut: "",});

    const setData = (nombres, apellido_p, apellido_m, correo) => {
 
        setNombre(nombres)
        setApellidoP(apellido_p)
        setApellidoM(apellido_m)
        setCorreo(correo)
        setTelefono(telefono)
       
    }

    const onCloseDialog = () => {
        setShowComprobante(true)
        setShow(false)
        
        clearData()
        closeModal()

    }


    const onSubmitClick = async () => {
        let auxRut = values.rut.replace(/\./g, "");
        

        let auxArr = 
        {
          
          rut: auxRut,  
          nombres: nombre,
          apellido_pat: apellidoP,
          apellido_mat: apellidoM,
          telefono_uno: telefono,
          email: correo,
          solicitud: solicitudConcreta ,
          observaciones: antecedentesgenerales 
        }
        console.log("aqui", auxArr)
        
        submitModal(auxArr)
        //console.log("aqui folio", folioInterno)
        setShow(!show)
        setShowComprobante(!showComprobante)
       // onCloseDialog()
    };

    const handleChangeTelefono = event => {
        setTelefono(event.target.value)
      }

    const clean = rut => {
        return typeof rut === "string"
            ? rut.replace(/^0+|[^0-9kK]+/g, "").toLowerCase()
            : ""
    }

    const cleanRut = clean;  

    const format = rut => {
        rut = clean(rut)
    
        var result = rut.slice(-4, -1) + "-" + rut.substr(rut.length - 1)
        for (var i = 4; i < rut.length; i += 3) {
            result = rut.slice(-3 - i, -i) + "." + result
        }
    
        return result
    }


    const handleChangeRut = event => {
    
            setRut(format(event.target.value))
         
      }
    
 


      const handleChangeNombre = event => {
        setNombre(event.target.value)
      }
    


      const hanldeChangeApellidoP = evt =>{
        setApellidoP(evt.target.value)
      }
    
      const hanldeChangeApellidoM = evt => {
        setApellidoM(evt.target.value)
      }

      const handleChangeCorreo = event => {
        setCorreo(event.target.value)
      }

      const handleChangeAntecedentesgenerales = evt => {
        setAntecedentesgenerales(evt.target.value)
      }

      const handleChangesolicitudconcreta = evt => {
        setSolicitudConcreta(evt.target.value)
    }

    const clearData = () => {
        setValues('')
        setRut('')
        setNombre('')
        setApellidoP('')
        setApellidoM('')
        setCorreo('')
        setTelefono(0)
        setAntecedentesgenerales('')
        setSolicitudConcreta('')
        setError("antecedentesgenerales", { type: "manual", message: "" })  
        setError("rut", { type: "manual", message: "" })
        setError("correo", {type: "manual", message:""})
    }



    const validarModalRut = () => {
        
         if(values.rut === '' ){
            setError("rut", { type: "manual", message: "Debe Ingresar el Rut" })
             return false
        }else{
            setError("rut", { type: "manual", message: "" })
            return true
        }    
    }


    const validateMail = mail => {
        //console.log('correo', mail)
        //eslint-disable-next-line
        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        if (mail !== null && mail !== "") {
          if (!mail.match(mailformat)) {
            return false
          } else {
            return true
          }
        }
      }
      
    const validaModalCorreo = mail => {
        
            if(validateMail(mail)===false ){
                setError("correo", {type: "manual", message:"Correo inválido"})
                return false
            }else{
           
                setError("correo", {type: "manual", message:""})
                return true
            }
   

    }



    const validarModalAGenerales = () => {
            if(antecedentesgenerales === '') {
                setError("antecedentesgenerales", { type: "manual", message: "Debe Ingresar Solicitud" })
                return false
            }else{
                setError("antecedentesgenerales", { type: "manual", message: "" })    
                return true
            } 
    } 

    const validarModal= () => {
        if (validarModalRut()=== true && validarModalAGenerales()=== true  ){
            return true
        }else{
            return false
        }

       
    
    }


    const cargaDatos = async (val) => {
      
        if(validate(cleanRut(val))){
            
            let rutSinDv = cleanRut(val).slice(0,-1)
            let respuesta = undefined
            respuesta = await getDatosCiudadanoPorRut(user, userLogOut, userLoggedIn)(rutSinDv)
           
            const resp_status = (respuesta || {}).status;
            if (resp_status === 200) {
                
                const results = await respuesta.json() 
                setData(results.nombres, results.apellido_p, results.apellido_m, results.email)    

                
            }

        }
    }

    
    useEffect(()=>{
    
        let val = rut.trim()
        cargaDatos(val)
    }, [rut] )

    return (
        <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={openDialog}
        onClose={onCloseDialog}
        aria-labelledby="responsive-dialog-title"
      >
       
            <DialogTitle className={classes.dialogTitleRoot} > {'Solicitud Interna (ATU)'}</DialogTitle>
            <DialogContent dividers>
               
               
                <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" style={{ marginBottom: 10 }}>
                    <Grid container spacing={2}>

                    
                    <Grid item xs={4} hidden={show}>
                            <TextField 
                            onBlur={() => cargaDatos(values.rut) }
                            onChange={({ target: { value } }) => value.length < 14 && setValues({ ...values, rut: format(value) })}
                            value={values.rut !== "" ? format(values.rut) : ""}
                            
                            id="rut"
                            fullWidth 
                            variant="outlined" 
                            label="*Rut" 
                            size="small" 
                            name="rut" 
                           
                            />
                            <ErrorMessage
                                style={{ color: 'red' }}
                                name="rut"
                                as="div"
                                errors={errors}
                            />
                    </Grid>


                    <Grid item xs={4} hidden={show}>
                        <TextField onChange={handleChangeNombre} 
                         id="input-id" variant="outlined" fullWidth  label="Nombre" size="small" name="nombre" value={nombre} />
                        <ErrorMessage
                            style={{ color: 'red' }}
                            name="nombre"
                            as="div"
                            errors={errors}
                        />
                    </Grid>


                    <Grid item xs={4} hidden={show}>
                        <TextField 
                        value={apellidoP} 
                        onChange={hanldeChangeApellidoP} 
                        id="input-id" 
                        fullWidth
                        variant="outlined" 
                        label="Apellido Paterno" 
                        size="small" 
                        name="apellidoP" />
                        <ErrorMessage
                            style={{ color: 'red' }}
                            name="apellidoP"
                            as="div"
                            errors={errors}
                        />
                    </Grid>

                    <Grid item xs={4} hidden={show}>
                        <TextField 
                        value={apellidoM} 
                        fullWidth
                        onChange={hanldeChangeApellidoM} 
                        id="input-id" 
                        variant="outlined" 
                        label="Apellido Materno" 
                        size="small" 
                        name="apellidoM" />
                        <ErrorMessage
                            style={{ color: 'red' }}
                            name="apellidoM"
                            as="div"
                            errors={errors}
                        />
                    </Grid>

                  
                   
                    <Grid item xs={4} hidden={show}>
                        <TextField 
                       
                        value={correo} 
                        fullWidth
                        onBlur={() => {
                            setCorreo(correo.trim())
                            validaModalCorreo(correo,"correo",setError, [{option:'eMail'}])}} 

                        onChange={handleChangeCorreo} 
                        id="input-id" 
                        variant="outlined" 
                        label="Correo" 
                        size="small" 
                        name="correo" />
                        <ErrorMessage
                            style={{ color: 'red' }}
                            name="correo"
                            as="div"
                            errors={errors}
                        />
                    </Grid>

                    <Grid item xs={4} hidden={show}>
                    <PhoneInput
                        defaultCountry="CL"
                        initialValueFormat="national"
                        maxlength="15"
                        international
                        withCountryCallingCode
                        placeholder="Telefono"
                        name="telefono"
                        value={telefono}
                        onChange={setTelefono} />
                    </Grid>
                    
                    <Grid item xs={12} hidden={show}>
                            <TextField fullWidth
                                id="antecedentesgenerales"
                                variant="outlined"
                                label="*¿Que Solicita?"
                                multiline
                                rows={4}
                                value={antecedentesgenerales}
                                onChange={handleChangeAntecedentesgenerales}
                                name="antecedentesgenerales"
                                onBlur={() => {
                                    if(validarModalAGenerales()){
                                                
                                        setValidateForm(false)
                                    }else{
                                        
                                        setValidateForm(true)
                                    }
                                    }}

                    />
                    <ErrorMessage
                            style={{ color: 'red' }}
                            name="antecedentesgenerales"
                            as="div"
                            errors={errors}
                        />
                    </Grid>

                    <Grid item xs={12} hidden={show}>
                            <TextField fullWidth
                               id="solicitudconcreta"
                               variant="outlined"
                               label="Observacion"
                               multiline
                               rows={4}
                               value={solicitudConcreta}
                               onChange={handleChangesolicitudconcreta}
                               name="solicitudconcreta"
                       

                    />
                    </Grid>

                    <Grid item xs={12} hidden={showComprobante}>
                        <h2 style={{ color: 'rgb(0, 0, 0)', fontSize: 16,  padding: 10 }}> 
                          
                            <h3 style={{ color: '#0064AC', fontSize: 16, fontWeight: 'bold',  padding:10, marginBottom:50 }}>Su solicitud ha sido ingresada con el siguiente número de folio:  {folioInterno}</h3>
                        </h2>
                    </Grid>

        </Grid>           
                </Box>

                <Box display="flex" justifyContent="flex-end" mb={4}>
                    <Button onClick={onCloseDialog} variant='contained' disabled={loading} >
                        Cerrar
                    </Button>
                    <Box ml={2}>

                        <Button variant="contained" hidden={show} style={{ backgroundColor: CORP_BLUE, color: 'white' }}  onClick={()=>{
                                if(validarModal()){
                                    onSubmitClick()
                                }else{
                                    setValidateForm(true)
                                }
                            }}>
                            {loading ? <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} /> : 'Aceptar'}
                        </Button>


                    </Box>
                </Box>
                
            </DialogContent>
        </Dialog>

    );
};

export default GestionesInternasModal;